// eslint-disable-next-line no-shadow
export enum PaginatorPosition {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}
